<div [class]="cssClass">
  <div *ngFor="let item of items">
    <button
      *ngIf="!item.divider && item"
      [class]="item.getActive && item.getActive() ? 'active' : ''"
      [title]="item.tooltip"
      [style.background-image]="'url(' + item.imageUrl + ')'"
      [style.display]="item.getHidden && item.getHidden() ? 'none' : 'inline'"
      (click)="execute(item)"
    ></button>
    <div *ngIf="item.divider" [class]="dividerClass"></div>
  </div>
  <div #extraItemsContainer></div>
</div>
